import { HsEngineObject } from './engine-object.class';

export class HsGroup extends HsEngineObject {}
